<!-- Content -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <!-- Solution -->
    <div class="flex column-gap-2 align-items-start">
      <medsurf-design-form-control-input-select-button [formField]="false"
        [control]="form.controls.solution"
        [options]="FlatModels.QuestionEntityModels.KPrimeQuestionSolutionArray"
        [allowEmpty]="false"
        (valueChange)="onChange()"></medsurf-design-form-control-input-select-button>
      <div medsurf-design-content-input-group class="w-full">
        <!-- Editor -->
        <medsurf-editor [formField]="false"
          [control]="form.controls.label"
          placeholder="global.answer"
        (valueChange)="onSubmit()"></medsurf-editor>
        <!-- Delete -->
        @if (question.type === FlatModels.QuestionEntityModels.QuestionType.enum.TrueFalseQuestion) {
          <button medsurf-design-input-button
            [id]="'k_prim_choice_remove'"
            [title]="'global.choice_remove' | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_FUllHEIGHT"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
          (click)="removeChoice()"></button>
        }
      </div>
    </div>
  </medsurf-design-form-control-form>
}
